export default "__VITE_ASSET__DMCy5kTf__"